
const state = {
  rightBlocks: null,
  leftBlocks: null,
  stickyHeader: null,
  landingCards: null,
  landingHeader: null,
  suppliercms: null



}
export default state